/* assets/ddi-pdp-gallery.js
   PERF F-20260908-72 (P16 document diet).

   The PDP gallery + variant-switch + add-to-cart + qty-stepper + zoom-hint controller. It
   used to be a 25.9 KB inline <script> in sections/ddi-pdp-hero.liquid - re-sent, uncached
   and parser-blocking, on every single product view. The P16 brief named it.

   Only 28 of its 516 lines needed Liquid, and all 28 were DATA, not logic: the section id,
   the image array, product.variants, the variant -> image index map, the option names, the
   is_preorder flag and the product id. Those now render as one small
   <script type="application/json" class="ddi-gallery-data"> island in the section, and this
   file - static and cacheable - reads it. No selector, branch or event name changed.

   One deliberate literal: the money-format fallback now reads '$'. In the .liquid file it
   was written with a Liquid placeholder that Liquid rendered to nothing, so the live page
   has always shipped a bare dollar sign. Verified against the live PDP before moving it.

   Loaded with defer, so it runs before DOMContentLoaded and the document.readyState guard
   at the bottom of the file behaves the same either way.
*/
(function() {
  'use strict';

  /* F-20260908-72: was 4 blocks of Liquid-rendered data; now one JSON island. */
  var __d = {};
  try {
    var __el = document.querySelector('script[type="application/json"].ddi-gallery-data');
    __d = JSON.parse(__el.textContent) || {};
  } catch (e) { __d = {}; }

  var GALLERY_ID        = __d.sectionId || '';
  var images            = __d.images || [];
  var variants          = __d.variants || [];
  var variantImageIndex = __d.variantImageIndex || {};
  var DDI_OPTION_NAMES  = __d.optionNames || [];
  var DDI_IS_PREORDER   = !!__d.isPreorder;
  var DDI_PRODUCT_ID    = __d.productId;

  /* PERF F-20260911-07: the section's JSON island still carries src600/src900/src1200, but
     since F-20260911-02 the main <img> and every mobile rail slide ship
     srcset="480w, 720w, 960w" with sizes="(max-width:860px) 86vw, 55vw". Rewriting the srcset
     back to the old three widths meant every thumb click, swipe and variant swap re-downloaded
     a photograph the browser had already painted, at a width nothing else on the page asks for.
     Derive the three live widths off the JSON URL's own width param instead, so swapping back
     to an image that is already on screen is a cache hit. Nothing in the markup moves, so no
     width/height attribute and no layout dimension changes. */
  function _atWidth(u, px) {
    if (!u) return u;
    var out = u.replace(/([?&]width=)\d+/i, '$1' + px);
    return out === u ? u : out;
  }

  // ---- Gallery thumb click ----
  function initGallery() {
    var mainImg = document.getElementById('ddi-main-img-' + GALLERY_ID);
    if (!mainImg) return;
    // Portrait detection on initial load
    if (mainImg.complete) {
      mainImg.classList.toggle('is-portrait', mainImg.naturalHeight > mainImg.naturalWidth * 1.15);
    } else {
      mainImg.addEventListener('load', function() { mainImg.classList.toggle('is-portrait', mainImg.naturalHeight > mainImg.naturalWidth * 1.15); }, { once: true });
    }

    var currentIdx = 0;
    function swapToIndex(idx) {
      if (!images[idx]) return;
      currentIdx = idx;
      var d = images[idx];
      var _s480 = _atWidth(d.src900, 480), _s720 = _atWidth(d.src900, 720), _s960 = _atWidth(d.src900, 960);
      mainImg.src = _s720;
      mainImg.srcset = _s480 + ' 480w, ' + _s720 + ' 720w, ' + _s960 + ' 960w';
      mainImg.alt = d.alt;
      mainImg.onload = function() { mainImg.classList.toggle('is-portrait', mainImg.naturalHeight > mainImg.naturalWidth * 1.15); };

      // Update active class on all thumb strips
      var allThumbs = document.querySelectorAll('[data-ddi-thumb][data-ddi-gallery="' + GALLERY_ID + '"]');
      allThumbs.forEach(function(t) {
        t.classList.toggle('is-active', parseInt(t.getAttribute('data-ddi-thumb'), 10) === idx);
      });

      // IDEA-WEB-20260709-01: swap per-image badge slides on the desktop main image.
      // Cover-only badges hide via CSS (data-active-image != "0"); per-image slides
      // are `.is-active` when their data-image-badge-slide matches the current index.
      var mainWrap = document.getElementById('ddi-main-image-' + GALLERY_ID);
      if (mainWrap) {
        mainWrap.setAttribute('data-active-image', idx);
        var slides = mainWrap.querySelectorAll('[data-image-badge-slide]');
        slides.forEach(function(s) {
          s.classList.toggle('is-active', parseInt(s.getAttribute('data-image-badge-slide'), 10) === idx);
        });
      }


    // PSI-WEB-20260701-05 offset fix: scroll ONLY the rail container, never the page.
    if (typeof window.__ddiRailScrollTo !== 'function') {
      window.__ddiRailScrollTo = function (container, el, align) {
        if (!container || !el) return;
        var cRect = container.getBoundingClientRect();
        var eRect = el.getBoundingClientRect();
        var delta = (align === 'center')
          ? (eRect.left + eRect.width / 2) - (cRect.left + cRect.width / 2)
          : (eRect.left - cRect.left);
        var target = container.scrollLeft + delta;
        var max = container.scrollWidth - container.clientWidth;
        if (target < 0) target = 0;
        if (target > max) target = max;
        try { container.scrollTo({ left: target, behavior: 'smooth' }); }
        catch (e) { container.scrollLeft = target; }
      };
    }
    var railScrollTo = window.__ddiRailScrollTo;

      // Scroll the mobile rail to the correct slide
      var rail = document.getElementById('ddi-rail-' + GALLERY_ID);
      if (rail) {
        var slide = rail.querySelector('[data-ddi-rail-img="' + idx + '"]');
        if (slide) { railScrollTo(rail, slide, 'start'); }
      }

      // Scroll the mobile thumb rail to keep active thumb visible
      var railThumbs = document.getElementById('ddi-thumb-strip-rail-' + GALLERY_ID);
      if (railThumbs) {
        var activeThumb = railThumbs.querySelector('[data-ddi-thumb="' + idx + '"]');
        if (activeThumb) { railScrollTo(railThumbs, activeThumb, 'center'); }
      }
    }

    // CRO-WEB-20260709-01 item 3: expose gallery swap so variant changes can drive the image
    window['__ddiSwap_' + GALLERY_ID] = swapToIndex;

    document.addEventListener('click', function(e) {
      var thumb = e.target.closest('[data-ddi-thumb][data-ddi-gallery="' + GALLERY_ID + '"]');
      if (!thumb) return;
      var idx = parseInt(thumb.getAttribute('data-ddi-thumb'), 10);
      swapToIndex(idx);
    });

    // Sync thumbnail active state when rail is swiped
    (function() {
      var rail = document.getElementById('ddi-rail-' + GALLERY_ID);
      if (!rail) return;
      var scrollTimer;
      rail.addEventListener('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() {
          var slides = [].slice.call(rail.querySelectorAll('[data-ddi-rail-img]'));
          var railLeft = rail.getBoundingClientRect().left;
          var closest = 0, minDist = Infinity;
          slides.forEach(function(s) {
            var dist = Math.abs(s.getBoundingClientRect().left - railLeft);
            if (dist < minDist) { minDist = dist; closest = parseInt(s.getAttribute('data-ddi-rail-img'), 10); }
          });
          if (closest !== currentIdx) {
            currentIdx = closest;
            var allThumbs = document.querySelectorAll('[data-ddi-thumb][data-ddi-gallery="' + GALLERY_ID + '"]');
            allThumbs.forEach(function(t) {
              t.classList.toggle('is-active', parseInt(t.getAttribute('data-ddi-thumb'), 10) === closest);
            });
            var railThumbsEl = document.getElementById('ddi-thumb-strip-rail-' + GALLERY_ID);
            if (railThumbsEl) {
              var at = railThumbsEl.querySelector('[data-ddi-thumb="' + closest + '"]');
              // F-20260924-57: railScrollTo is scoped to swapToIndex, so this swipe handler threw
              // "Can't find variable: railScrollTo" on every mobile swipe. Call the shared helper.
              if (at && typeof window.__ddiRailScrollTo === 'function') { window.__ddiRailScrollTo(railThumbsEl, at, 'center'); }
              else if (at) { var cR = railThumbsEl.getBoundingClientRect(), aR = at.getBoundingClientRect(); railThumbsEl.scrollLeft += (aR.left + aR.width / 2) - (cR.left + cR.width / 2); }
            }
          }
        }, 80);
      }, { passive: true });
    })();

    // ---- Swipe on main image (mobile / touch) ----
    var stage = document.getElementById('ddi-main-image-' + GALLERY_ID);
    if (stage && images.length > 1) {
      var touchX = 0, touchY = 0, swiping = false;
      stage.addEventListener('touchstart', function(e) {
        var t = e.changedTouches[0];
        touchX = t.clientX; touchY = t.clientY; swiping = true;
      }, { passive: true });
      stage.addEventListener('touchend', function(e) {
        if (!swiping) return;
        swiping = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - touchX, dy = t.clientY - touchY;
        // horizontal intent only, 40px threshold
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        var next = dx < 0 ? currentIdx + 1 : currentIdx - 1;
        if (next < 0) next = images.length - 1;
        if (next >= images.length) next = 0;
        swapToIndex(next);
      }, { passive: true });
    }
  }

  // ---- Variant selection ----
  function initVariants() {
    var form = document.getElementById('ddi-hero-form-' + GALLERY_ID);
    if (!form) return;

    var variantInput = form.querySelector('[data-ddi-variant-id]');
    var atcBtn = document.getElementById('ddi-hero-atc-' + GALLERY_ID);
    var atcLabel = document.getElementById('ddi-hero-atc-label-' + GALLERY_ID);
    var priceBlock = document.getElementById('ddi-hero-price-' + GALLERY_ID);
    var afterpayEl = document.getElementById('ddi-hero-afterpay-' + GALLERY_ID);
    var stockEl = document.getElementById('ddi-hero-stock-' + GALLERY_ID);

    // Also update the hidden Krown shim form
    var shimInput = document.querySelector('#ddi-krown-shim-' + GALLERY_ID + ' .product-variant-value');

    // Collect all option inputs in the section
    var optionInputs = document.querySelectorAll(
      '#ddi-hero-form-' + GALLERY_ID + ' .product-variant-value, ' +
      '.ddi-pdp-hero-section .product-variant__input'
    );

    function getSelectedOptions() {
      var selected = {};
      document.querySelectorAll('.ddi-pdp-hero-section .product-variant__input').forEach(function(inp) {
        if (inp.checked || inp.type !== 'radio') {
          var name = inp.name;
          // extract option index from name pattern: product-optionname-sectionid
          selected[name] = inp.value;
        }
      });
      return selected;
    }

    function findVariant() {
      var optionVals = [];
      
      
      DDI_OPTION_NAMES.forEach(function(optName) {
        /* F-20260908-72: was a Liquid-interpolated option name; now concatenated at runtime.
           Renders the same selector, e.g. input[name*="color-"]. */
        var inputs = document.querySelectorAll('.ddi-pdp-hero-section input[name*="' + optName + '-"]');
        if (inputs.length) {
          for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].checked) { optionVals.push(inputs[i].value); break; }
          }
        }
      });
      

      if (optionVals.length === 0) return null;

      for (var v = 0; v < variants.length; v++) {
        var vt = variants[v];
        var match = true;
        for (var o = 0; o < optionVals.length; o++) {
          if (vt['option' + (o + 1)] !== optionVals[o]) { match = false; break; }
        }
        if (match) return vt;
      }
      return null;
    }

    function fmtMoney(cents) {
      var fmt = (window.KROWN && KROWN.settings && KROWN.settings.shop_money_format) || '$' /* F-20260908-72: the Liquid money-format placeholder rendered to nothing, so live shipped a bare dollar sign; kept verbatim */;
      var d = (cents / 100).toFixed(2);
      return fmt
        .replace(/\{\{\s*amount\s*\}\}/g, d)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100));
    }

    function onVariantChange() {
      var vt = findVariant();
      if (!vt) return;

      // Update hidden inputs
      if (variantInput) variantInput.value = vt.id;
      if (shimInput) shimInput.value = vt.id;

      // Update URL without triggering Krown pushState
      var newUrl = window.location.pathname + '?variant=' + vt.id;
      history.replaceState({ variantId: vt.id }, '', newUrl);

      // Update ATC button
      if (atcBtn && atcLabel) {
        if (vt.available) {
          atcBtn.disabled = false;
          /* F-20260904-05: this hard-coded 'Add to Cart' wiped the 'Pre-Order' label
               on a variant switch for any multi-variant pre-order product. is_preorder is a
               product-level tag, so it holds for every variant. The sticky ATC below already
               restores its own original text via __ddiOrigText. */
          atcLabel.textContent = DDI_IS_PREORDER ? 'Pre-Order' : 'Add to Cart';
        } else {
          atcBtn.disabled = true;
          atcLabel.textContent = 'Sold Out';
        }
      }


      // BIS show/hide on variant change
      var bisEl = document.getElementById('ddi-hero-bis-' + GALLERY_ID);
      if (bisEl) {
        bisEl.setAttribute('data-bis-variant', vt.id);
        if (vt.available) {
          bisEl.classList.add('ddi-hero__bis--hidden');
        } else {
          bisEl.classList.remove('ddi-hero__bis--hidden');
          var bisForm = bisEl.querySelector('.ddi-hero__bis-form');
          var bisSuccess = bisEl.querySelector('.ddi-hero__bis-success');
          var bisError = bisEl.querySelector('.ddi-hero__bis-error');
          if (bisSuccess) bisSuccess.style.display = 'none';
          if (bisForm) bisForm.style.display = '';
          if (bisError) { bisError.style.display = 'none'; bisError.textContent = ''; }
          var bisBtn = bisEl.querySelector('.ddi-hero__bis-submit');
          if (bisBtn) { bisBtn.disabled = false; bisBtn.textContent = 'Notify me'; }
        }
      }

      // Update price block. CRO F-20260720-34 Q7: Rule of 100 - show % under $100, $ otherwise.
      if (priceBlock) {
        var priceHtml = '<span class="ddi-hero__price">' + fmtMoney(vt.price) + '</span>';
        if (vt.compare_at_price && vt.compare_at_price > vt.price) {
          var save = vt.compare_at_price - vt.price;
          var saveTxt;
          if (vt.compare_at_price < 10000) {
            var pct = Math.round(save * 100 / vt.compare_at_price);
            saveTxt = 'Save ' + pct + '%';
          } else {
            saveTxt = 'Save ' + fmtMoney(save).replace(/\.00$/, '');
          }
          priceHtml += ' <span class="ddi-hero__price-compare">' + fmtMoney(vt.compare_at_price) + '</span>';
          priceHtml += ' <span class="ddi-hero__price-save">' + saveTxt + '</span>';
        }
        priceBlock.innerHTML = priceHtml;
      }

      // CRO F-20260720-34 Q4: also toggle the "On Sale" tag near the price when a variant
      // moves between on-sale and full-price states.
      var saleTagEl = document.querySelector('.ddi-pdp-hero-section .ddi-hero__sale-tag');
      if (saleTagEl) {
        saleTagEl.style.display = (vt.compare_at_price && vt.compare_at_price > vt.price) ? '' : 'none';
      }

      // CRO F-20260720-34 Q7: keep the top-left card pill in Rule-of-100 sync too.
      var cardPills = document.querySelectorAll('.ddi-pdp-hero-section [data-ddi-card-save]');
      if (cardPills.length) {
        var cardTxt = '';
        if (vt.compare_at_price && vt.compare_at_price > vt.price) {
          var vSave = vt.compare_at_price - vt.price;
          if (vt.compare_at_price < 10000) {
            var vPct = Math.round(vSave * 100 / vt.compare_at_price);
            cardTxt = '-' + vPct + '%';
          } else {
            cardTxt = '-' + fmtMoney(vSave).replace(/\.00$/, '');
          }
        }
        cardPills.forEach(function(p) {
          if (cardTxt) { p.textContent = cardTxt; p.style.display = ''; }
          else { p.style.display = 'none'; }
        });
      }

      // Update Afterpay line
      if (afterpayEl) {
        afterpayEl.innerHTML = 'or 4 x <strong>' + fmtMoney(Math.round(vt.price / 4)) + '</strong> with <span class="ddi-hero__afterpay-mark" role="img" aria-label="Afterpay">Afterpay</span>';
      }

      // CRO-WEB-20260709-01 item 3: keep sticky bar, stock line and gallery image in sync with the variant
      var stickyPriceEl = document.getElementById('ddi-sticky-price-' + GALLERY_ID);
      if (stickyPriceEl) {
        var spHtml = fmtMoney(vt.price);
        if (vt.compare_at_price && vt.compare_at_price > vt.price) {
          spHtml += ' <del>' + fmtMoney(vt.compare_at_price) + '</del>';
        }
        stickyPriceEl.innerHTML = spHtml;
      }
      var stickyBtnEl = document.querySelector('[data-ddi-sticky-atc-btn]');
      if (stickyBtnEl) {
        if (typeof stickyBtnEl.__ddiOrigText === 'undefined') { stickyBtnEl.__ddiOrigText = stickyBtnEl.textContent; }
        if (vt.available) {
          stickyBtnEl.disabled = false;
          stickyBtnEl.removeAttribute('aria-disabled');
          stickyBtnEl.textContent = stickyBtnEl.__ddiOrigText;
        } else {
          stickyBtnEl.disabled = true;
          stickyBtnEl.setAttribute('aria-disabled', 'true');
          stickyBtnEl.textContent = 'Sold Out';
        }
      }
      if (stockEl) { stockEl.style.display = vt.available ? '' : 'none'; }
      if (variantImageIndex[vt.id] != null && typeof window['__ddiSwap_' + GALLERY_ID] === 'function') {
        window['__ddiSwap_' + GALLERY_ID](variantImageIndex[vt.id]);
      }

      // Update selected value labels
      [vt.option1, vt.option2, vt.option3].forEach(function(val, idx) {
        if (!val) return;
        var labelEl = document.querySelector('.ddi-hero__form [data-ddi-selected-val="' + idx + '"]');
        if (labelEl) labelEl.textContent = val;
      });

      // Dispatch Krown-compatible variant change event
      var event = new CustomEvent('variant:changed', {
        bubbles: true,
        detail: { variant: vt, productId: DDI_PRODUCT_ID }
      });
      document.dispatchEvent(event);
    }

    // Listen on all variant radio inputs inside the hero section
    document.addEventListener('change', function(e) {
      if (e.target.classList.contains('product-variant__input') &&
          e.target.closest('.ddi-pdp-hero-section')) {
        onVariantChange();
      }
    });
  }

  /* F-20260908-72: window.ddiBisNotify - the back-in-stock signup, which POSTs to our email
     platform - is DELIBERATELY NOT in this file. It stays as an inline <script> in the
     section. P16's hard constraint is that no marketing or analytics call moves, and
     relocating one into a deferred asset is still moving it. initBIS() stays the no-op it
     has always been, so the two call sites at the bottom of this file are unchanged. */
  function initBIS() {}

  // ---- ATC: intercept form submit -> Krown drawer ----
  function initATC() {
    var form = document.querySelector('.ddi-hero__product-form');
    if (!form) return;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      // Ensure the qty stepper value is written into the hidden field before submit.
      var qtyIn = form.querySelector('[data-ddi-qty-input]');
      if (qtyIn) {
        var q = parseInt(qtyIn.value, 10);
        if (!(q > 0)) { q = 1; qtyIn.value = '1'; }
      }
      if (typeof window.handleAddToCart !== 'function') {
        // Fallback: open drawer manually after native submit
        form.submit();
        return;
      }
      var btn = form.querySelector('.ddi-hero__atc');
      var label = form.querySelector('#ddi-hero-atc-label-' + GALLERY_ID);
      var origText = label ? label.textContent : 'Add to Cart';
      if (btn) btn.disabled = true;
      if (label) label.textContent = 'Adding...';
      var params = new URLSearchParams(new FormData(form)).toString();
      window.handleAddToCart(params, 1, {'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest'}, function() {
        if (btn) btn.disabled = false;
        if (label) label.textContent = origText;
      });
    });
  }

  // ---- CRO F-20260720-34 Q6: quantity stepper ----
  function initQtyStepper() {
    var wrap = document.querySelector('[data-ddi-qty="' + GALLERY_ID + '"]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-ddi-qty-input]');
    var minus = wrap.querySelector('[data-ddi-qty-minus]');
    var plus = wrap.querySelector('[data-ddi-qty-plus]');
    if (!input) return;
    function clamp(v) {
      var n = parseInt(v, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 99) n = 99;
      return n;
    }
    function sync() {
      input.value = clamp(input.value);
      if (minus) minus.disabled = (parseInt(input.value, 10) <= 1);
    }
    if (minus) minus.addEventListener('click', function() { input.value = clamp(parseInt(input.value, 10) - 1); sync(); });
    if (plus)  plus.addEventListener('click',  function() { input.value = clamp(parseInt(input.value, 10) + 1); sync(); });
    input.addEventListener('change', sync);
    input.addEventListener('blur', sync);
    sync();
  }

  // ---- CRO F-20260720-34 Q5 (v2 perf): pinch/tap-to-zoom hint session bookkeeping ----
  // The fade animation runs purely in CSS (starts at HTML parse). This function only:
  //   (a) records that the hint has been shown once the animation finishes, and
  //   (b) dismisses the hint early if the user taps/clicks the hero image.
  // The synchronous inline script BEFORE the hint HTML handles the "already seen" case by
  // writing `display:none` before the parser reaches the hint - so this JS never has to fight
  // a repeat-visit flash.
  function initZoomHint() {
    var hint = document.getElementById('ddi-hero-zoom-hint-' + GALLERY_ID);
    if (!hint) return;
    var key = 'ddiZoomHintShown_' + DDI_PRODUCT_ID;
    var mark = function() { try { sessionStorage.setItem(key, '1'); } catch (e) {} };
    hint.addEventListener('animationend', mark, { once: true });
    var stage = document.getElementById('ddi-main-image-' + GALLERY_ID);
    if (stage) {
      var dismiss = function() { hint.classList.add('ddi-hero__zoom-hint--dismissed'); mark(); };
      stage.addEventListener('click', dismiss, { once: true });
      stage.addEventListener('touchstart', dismiss, { once: true, passive: true });
    }
  }

  // ---- A/B pdp-zoom-v1 (F-20260924-75): mobile tap-to-zoom lightbox ----
  // Spec: DDI_ABTest/PDP_ZOOM_V1_SPEC_F-20260924-72.md. PHONES ONLY.
  //  - The test root is stamped by JS only when the mobile thumb-strip breakpoint matches at
  //    load, because the tracker counts every [data-ab-root] in the DOM, visible or not.
  //  - photo-tap (both arms) and zoom-swipe (variant) are sent straight to the tracker's event
  //    endpoint, NOT via data-ab-action: the whole hero sits inside the multibuy-pills-v1 root,
  //    and the tracker binds an action to the FIRST root that contains it, so an attribute
  //    here would be credited to multibuy-pills-v1.
  //  - The overlay (.ddi-pdp-zoom) is position:fixed and built on the first tap, so nothing
  //    enters the page flow. Control never builds it. No-JS = control.
  // Remove this block (and its two init calls) when the experiment ends.
  var ZOOM_EXP = 'pdp-zoom-v1';
  var ZOOM_MQ = '(max-width:860px)';   /* same breakpoint as .ddi-hero__thumbs-h--rail */
  var ZOOM_EVT = 'https://track.dennisdidit.com/abtest/api/event';

  function zoomIsMobile() {
    try { return !!(window.matchMedia && window.matchMedia(ZOOM_MQ).matches); } catch (e) { return false; }
  }
  var zoomRooted = false;
  function zoomStampRoot() {
    if (!zoomIsMobile()) return;
    var rail = document.getElementById('ddi-rail-' + GALLERY_ID);
    var gal = rail && rail.closest('.ddi-hero__gallery');
    if (!gal) return;
    // F-20261010-09: Theo turned the zoom on for every phone (11 Oct). pdp-zoom-v1 is not in the
    // live test config, so no test root is stamped and zoomEvent() stays silent.
    zoomRooted = true;
  }
  function zoomArm() {
    return zoomRooted ? ((window._DDI_AB || {})[ZOOM_EXP] || null) : null;
  }
  function zoomEvent(action) {
    var v = zoomArm(); if (!v) return;
    var u = ZOOM_EVT + '?exp=' + encodeURIComponent(ZOOM_EXP) + '&v=' + encodeURIComponent(v) + '&action=' + encodeURIComponent(action);
    try { navigator.sendBeacon(u); } catch (_) { try { fetch(u, { method: 'POST', keepalive: true, mode: 'no-cors' }); } catch (e) {} }
  }
  function zoomIsVariant() {
    return zoomRooted && zoomIsMobile();
  }

  var ZOOM_CSS =
    '.ddi-pdp-zoom{position:fixed;left:0;top:0;width:100%;height:100%;z-index:2147483646;background:#0c0c0e;overflow:hidden;touch-action:none;overscroll-behavior:contain;-webkit-user-select:none;user-select:none;opacity:1;}' +
    '.ddi-pdp-zoom[hidden]{display:none;}' +
    '.ddi-pdp-zoom__track{position:absolute;left:0;top:0;height:100%;display:flex;will-change:transform;}' +
    '.ddi-pdp-zoom__slide{position:relative;flex:0 0 auto;height:100%;overflow:hidden;}' +
    '.ddi-pdp-zoom__zoom{position:absolute;left:0;top:0;width:100%;height:100%;transform-origin:50% 50%;will-change:transform;}' +
    /* the theme sets img{transform:none!important}, so zoom transforms the wrapper above, never the img */
    '.ddi-pdp-zoom__img{position:absolute;left:0;top:0;width:100%;height:100%;object-fit:contain;-webkit-user-drag:none;pointer-events:none;}' +
    '.ddi-pdp-zoom__close{position:absolute;top:calc(8px + env(safe-area-inset-top));right:8px;width:44px;height:44px;padding:0;border:0;border-radius:50%;background:rgba(12,12,14,.55);color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;z-index:2;}' +
    '.ddi-pdp-zoom__close svg{width:20px;height:20px;display:block;}' +
    '.ddi-pdp-zoom__count{position:absolute;left:0;right:0;bottom:calc(14px + env(safe-area-inset-bottom));text-align:center;color:#fff;font:11px/1 Switzer,sans-serif;letter-spacing:.1em;opacity:.85;pointer-events:none;z-index:2;}';

  function initZoom() {
    var rail = document.getElementById('ddi-rail-' + GALLERY_ID);
    if (!rail || !images.length) return;
    var strip = document.getElementById('ddi-thumb-strip-rail-' + GALLERY_ID);

    var ov = null, track = null, slides = [], countEl = null, closeBtn = null;
    var isOpen = false, idx = 0, startIdx = 0, swiped = false, viaHistory = false;
    var W = 0, H = 0, lastFocus = null, savedOverflow = '', savedY = 0;
    var s = 1, tx = 0, ty = 0;   /* zoom state of the current slide */

    function fitBox(i) {
      var im = slides[i] && slides[i].img;
      var nw = (im && im.naturalWidth) || 1, nh = (im && im.naturalHeight) || 1;
      var r = Math.min(W / nw, H / nh);
      return { w: nw * r, h: nh * r };
    }
    function clampPan() {
      var b = fitBox(idx);
      var mx = Math.max(0, (b.w * s - W) / 2), my = Math.max(0, (b.h * s - H) / 2);
      tx = Math.max(-mx, Math.min(mx, tx));
      ty = Math.max(-my, Math.min(my, ty));
    }
    function applyZoom(anim) {
      var im = slides[idx] && slides[idx].zw; if (!im) return;
      im.style.transition = anim ? 'transform .22s ease' : 'none';
      im.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')';
    }
    function resetZoom(i) {
      var im = slides[i] && slides[i].zw;
      if (im) { im.style.transition = 'none'; im.style.transform = ''; }
    }
    function setTrack(dx, anim) {
      track.style.transition = anim ? 'transform .25s ease' : 'none';
      track.style.transform = 'translate3d(' + (-idx * W + dx) + 'px,0,0)';
    }
    function loadBig(i) {
      var sl = slides[i]; if (!sl || sl.big) return;
      sl.big = true;
      var d = images[i]; var url = d && (d.src1200 || d.src900); if (!url) return;
      var pre = new Image();
      pre.onload = function() { sl.img.src = url; };
      pre.src = url;
    }
    function layout() {
      W = ov.clientWidth; H = ov.clientHeight;
      slides.forEach(function(sl) { sl.el.style.width = W + 'px'; });
      track.style.width = (W * slides.length) + 'px';
      setTrack(0, false);
    }
    function go(i, anim) {
      if (i < 0) i = 0;
      if (i > slides.length - 1) i = slides.length - 1;
      if (i !== idx) { resetZoom(idx); s = 1; tx = 0; ty = 0; }
      idx = i;
      setTrack(0, anim);
      countEl.textContent = (idx + 1) + ' / ' + slides.length;
      loadBig(idx); loadBig(idx + 1); loadBig(idx - 1);
      if (idx !== startIdx && !swiped) { swiped = true; zoomEvent('zoom-swipe'); }
    }

    function build() {
      var st = document.createElement('style');
      st.id = 'ddi-pdp-zoom-css';
      st.textContent = ZOOM_CSS;
      document.head.appendChild(st);

      ov = document.createElement('div');
      ov.className = 'ddi-pdp-zoom';
      ov.setAttribute('role', 'dialog');
      ov.setAttribute('aria-modal', 'true');
      ov.setAttribute('aria-label', 'Product images');
      ov.hidden = true;
      track = document.createElement('div');
      track.className = 'ddi-pdp-zoom__track';
      images.forEach(function(d, i) {
        var el = document.createElement('div');
        el.className = 'ddi-pdp-zoom__slide';
        var im = document.createElement('img');
        im.className = 'ddi-pdp-zoom__img';
        im.alt = d.alt || '';
        im.decoding = 'async';
        im.draggable = false;
        // Start on the rail photo the browser already has, then swap to 1200w once loaded.
        var railImg = rail.querySelector('[data-ddi-rail-img="' + i + '"] img');
        var seed = railImg && railImg.complete && railImg.naturalWidth ? (railImg.currentSrc || railImg.src) : '';
        if (seed) im.src = seed;
        var zw = document.createElement('div');
        zw.className = 'ddi-pdp-zoom__zoom';
        zw.appendChild(im);
        el.appendChild(zw);
        track.appendChild(el);
        slides.push({ el: el, zw: zw, img: im, big: false });
      });
      closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'ddi-pdp-zoom__close';
      closeBtn.setAttribute('aria-label', 'Close');
      closeBtn.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" fill="none"/></svg>';
      countEl = document.createElement('div');
      countEl.className = 'ddi-pdp-zoom__count';
      countEl.setAttribute('aria-live', 'polite');
      ov.appendChild(track); ov.appendChild(closeBtn); ov.appendChild(countEl);
      document.body.appendChild(ov);

      closeBtn.addEventListener('click', function(e) { e.stopPropagation(); requestClose(); });
      ov.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') requestClose();
        else if (e.key === 'ArrowRight') go(idx + 1, true);
        else if (e.key === 'ArrowLeft') go(idx - 1, true);
      });
      window.addEventListener('resize', function() { if (isOpen) { s = 1; tx = 0; ty = 0; resetZoom(idx); layout(); } });
      bindGestures();
    }

    function bindGestures() {
      var mode = null, x0 = 0, y0 = 0, t0 = 0, dx = 0, dy = 0, tx0 = 0, ty0 = 0;
      var pinchD0 = 0, pinchS0 = 1, pmx = 0, pmy = 0;
      var lastTap = 0, lastTapX = 0, lastTapY = 0;
      function dist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }

      ov.addEventListener('touchstart', function(e) {
        if (e.target.closest('.ddi-pdp-zoom__close')) return;
        if (e.touches.length === 2) {
          mode = 'pinch';
          var a = e.touches[0], b = e.touches[1];
          pinchD0 = dist(a, b) || 1; pinchS0 = s; tx0 = tx; ty0 = ty;
          pmx = (a.clientX + b.clientX) / 2 - W / 2; pmy = (a.clientY + b.clientY) / 2 - H / 2;
          return;
        }
        if (e.touches.length !== 1) return;
        var t = e.touches[0];
        x0 = t.clientX; y0 = t.clientY; t0 = Date.now(); dx = 0; dy = 0; tx0 = tx; ty0 = ty;
        mode = s > 1.01 ? 'pan' : 'pending';
      }, { passive: true });

      ov.addEventListener('touchmove', function(e) {
        if (e.cancelable) e.preventDefault();   /* no page scroll or browser pinch behind the overlay */
        if (mode === 'pinch' && e.touches.length === 2) {
          var a = e.touches[0], b = e.touches[1];
          var ns = Math.max(1, Math.min(4, pinchS0 * dist(a, b) / pinchD0));
          tx = pmx - (pmx - tx0) * (ns / pinchS0);
          ty = pmy - (pmy - ty0) * (ns / pinchS0);
          s = ns; clampPan(); applyZoom(false);
          return;
        }
        if (e.touches.length !== 1) return;
        var t = e.touches[0];
        dx = t.clientX - x0; dy = t.clientY - y0;
        if (mode === 'pending' && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
          mode = Math.abs(dx) >= Math.abs(dy) ? 'swipe' : (dy > 0 ? 'down' : 'none');
        }
        if (mode === 'swipe') {
          var edge = (idx === 0 && dx > 0) || (idx === slides.length - 1 && dx < 0);
          setTrack(edge ? dx / 3 : dx, false);
        } else if (mode === 'down') {
          track.style.transition = 'none';
          track.style.transform = 'translate3d(' + (-idx * W) + 'px,' + dy + 'px,0)';
          ov.style.transition = 'none';
          ov.style.opacity = String(Math.max(0.3, 1 - dy / (H * 0.9)));
        } else if (mode === 'pan') {
          tx = tx0 + dx; ty = ty0 + dy; clampPan(); applyZoom(false);
        }
      }, { passive: false });

      ov.addEventListener('touchend', function(e) {
        if (e.touches.length) {   /* lifted one finger of a pinch: continue as a pan */
          if (mode === 'pinch' && e.touches.length === 1) {
            var r = e.touches[0]; x0 = r.clientX; y0 = r.clientY; tx0 = tx; ty0 = ty; dx = 0; dy = 0;
            mode = s > 1.01 ? 'pan' : 'none';
          }
          return;
        }
        var dt = Date.now() - t0;
        if (mode === 'swipe') {
          var fast = dt < 300 && Math.abs(dx) > 30;
          if (dx < -W * 0.2 || (fast && dx < 0)) go(idx + 1, true);
          else if (dx > W * 0.2 || (fast && dx > 0)) go(idx - 1, true);
          else setTrack(0, true);
        } else if (mode === 'down') {
          if (dy > 110 || (dt < 300 && dy > 50)) { requestClose(); }
          else {
            track.style.transition = 'transform .2s ease';
            track.style.transform = 'translate3d(' + (-idx * W) + 'px,0,0)';
            ov.style.transition = 'opacity .2s ease'; ov.style.opacity = '1';
          }
        } else if (mode === 'pending' || (mode === 'pan' && Math.abs(dx) < 8 && Math.abs(dy) < 8)) {
          var ct = e.changedTouches[0], now = Date.now();
          if (now - lastTap < 300 && Math.hypot(ct.clientX - lastTapX, ct.clientY - lastTapY) < 30) {
            lastTap = 0;
            if (s > 1.01) { s = 1; tx = 0; ty = 0; }
            else {
              var ns = 2.5, px = ct.clientX - W / 2, py = ct.clientY - H / 2;
              tx = px - px * ns; ty = py - py * ns; s = ns; clampPan();
            }
            applyZoom(true);
          } else { lastTap = now; lastTapX = ct.clientX; lastTapY = ct.clientY; }
        }
        mode = null;
      }, { passive: true });
    }

    function open(i) {
      if (isOpen) return;
      if (!ov) build();
      isOpen = true; swiped = false; startIdx = i; s = 1; tx = 0; ty = 0;
      lastFocus = document.activeElement;
      savedY = window.pageYOffset;
      savedOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      ov.style.transition = 'none'; ov.style.opacity = '1';
      ov.hidden = false;
      idx = i; layout(); go(i, false);
      try { history.pushState({ ddiZoom: 1 }, ''); viaHistory = true; } catch (e) { viaHistory = false; }
      try { closeBtn.focus({ preventScroll: true }); } catch (e) {}
    }
    function finishClose() {
      if (!isOpen) return;
      isOpen = false;
      resetZoom(idx);
      // Land the rail and thumb strip on the image last viewed, while the overlay still covers them.
      var fn = window['__ddiSwap_' + GALLERY_ID];
      if (typeof fn === 'function') fn(idx);
      ov.hidden = true;
      ov.style.opacity = '1';
      document.documentElement.style.overflow = savedOverflow;
      if (Math.abs(window.pageYOffset - savedY) > 1) window.scrollTo(0, savedY);
      try { if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
    function requestClose() {
      if (!isOpen) return;
      if (viaHistory && history.state && history.state.ddiZoom) { history.back(); }   /* popstate finishes */
      else finishClose();
    }
    window.addEventListener('popstate', function() { if (isOpen) { viaHistory = false; finishClose(); } });

    // Capture phase: runs before the gallery's own thumb handler flips .is-active.
    document.addEventListener('click', function(e) {
      if (!zoomRooted || !zoomIsMobile()) return;
      var slide = e.target.closest('.ddi-hero__rail-slide[data-ddi-gallery="' + GALLERY_ID + '"]');
      var thumb = !slide && strip && e.target.closest('.ddi-hero__thumb.is-active');
      if (thumb && !strip.contains(thumb)) thumb = null;
      if (!slide && !thumb) return;
      if (e.target.closest('a,button,input,select,textarea')) return;   /* badge links etc. */
      zoomEvent('photo-tap');
      if (!zoomIsVariant()) return;
      var i = parseInt((slide || thumb).getAttribute(slide ? 'data-ddi-rail-img' : 'data-ddi-thumb'), 10);
      if (isNaN(i) || !images[i]) return;
      e.preventDefault(); e.stopPropagation();
      open(i);
    }, true);
  }
  // Stamp the phone-only root now: this deferred file runs before DOMContentLoaded, so the
  // tracker's first scan already sees it.
  try { zoomStampRoot(); } catch (e) {}

  // ---- Init ----
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initGallery();
      initVariants();
      initATC();
      initQtyStepper();
      initZoomHint();
      initZoom();
    });
  } else {
    initGallery();
    initVariants();
    initBIS();
    initATC();
    initQtyStepper();
    initZoomHint();
    initZoom();
  }

}());
